import { render, staticRenderFns } from "./DeleteItemGroupModal.vue?vue&type=template&id=e6d1ddea&"
import script from "./DeleteItemGroupModal.vue?vue&type=script&lang=js&"
export * from "./DeleteItemGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src150092593/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e6d1ddea')) {
      api.createRecord('e6d1ddea', component.options)
    } else {
      api.reload('e6d1ddea', component.options)
    }
    module.hot.accept("./DeleteItemGroupModal.vue?vue&type=template&id=e6d1ddea&", function () {
      api.rerender('e6d1ddea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/items/DeleteItemGroupModal.vue"
export default component.exports